
import { createPortal, } from "react-dom";
import { getUsableChains, } from "./chains";
import { wagmiConfig, } from "@config";
import { switchChain, } from "wagmi/actions";
import type { BaseChainId } from "@types";
import type { FunctionComponent, } from "react"

export declare type ChooseChainDDProps = {
	rect: DOMRect;
	onMouseDownOut?: () => void;
};


export const ChooseChainDD: FunctionComponent<ChooseChainDDProps> = ({
	rect,
}) => {

	const classes = () => [ "conn-man", "dropdown-panel", "select-chain" ].join(" ");
	const el = document.getElementById("connManUIRoot");
	const { clientWidth, } = document.body;
	const style = () => ({
		right: clientWidth - rect.right,
		top: rect.top + rect.height,
	});

	const onSelect = ( evt: any, chainId: BaseChainId, ) => ( async () => {
		evt.stopPropagation();
		evt.preventDefault();
		try {
			await switchChain(wagmiConfig, { chainId, });
		}
		catch( err:any ) {
			if(err && err.code === 4001) {
				// user cancelled
				return;
			}
			throw err;
		}
	})();

	if( el ) {
		return createPortal (
			<div className={classes()} style={style()} >
			{
				Object.values(getUsableChains()).map(( chain, id ) => {
					return (
						<div key={id} className="item" onMouseDown={evt => onSelect(evt, chain.chainId) }>
							<div className="icon" style={{ backgroundImage: `url(${chain.icon})`, }} />
							<div className="name"><span className="label">{chain.label}</span></div>
						</div>
					)
				})
			}
			</div>,
			el
		);
	}
	throw new Error("ConnectionManager::ChooseChainDD could not locate the UI root");
}
